<template>
  <div class="seriesOfClass-edit">
    <div class="white-container full-page-container common-table">
      <div class="top-title">关联商品配置</div>
      <el-form class="search-bar" :inline="true" size="small">
        <el-form-item class="search-form-item">
          <el-input v-model="search.sku" placeholder="搜索商品名称或SKU" prefix-icon="el-icon-search" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchSubmit">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-table ref="searchTable" size="small" :data="searchList" style="width: 100%"> -->
      <div class="table-wrap">
        <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.equipment.getEquipmentBySku" style="width: 100%">
          <el-table-column prop="productNo" label="商品SKU" />
          <el-table-column prop="productName" label="商品名称" />
          <el-table-column prop="categories" label="分类">
            <template v-slot="{ row }">
              <template v-if="row.categories">
                <div v-for="item in row.categories.split('，')" :key="item">{{ item }}</div>
              </template>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="newFlag" label="是否新品">
            <template v-slot="{ row }">
              {{ row.newFlag === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="mediaLink" label="商品图片">
            <template v-slot="{row}">
              <div class="img-box" style="width:75px; height: 75px">
                <img v-if="row.isDelete === 1" class="invalid-flag" src="@/assets/images/product-invalid.svg">
                <img v-if="row.mediaLink" class="product-img" :src="row.mediaLink" alt="">
                <div v-else style="line-height: 75px;">--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qty" label="库存" />
          <el-table-column prop="soldQty" label="销量" />
          <el-table-column prop="isHot" label="是否热卖商品">
            <template v-slot="{ row }">
              {{ row.isHot === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="{row}">
              <el-button v-if="row.isDelete === 0" size="small" type="text" class="link-color" @click="add(row)">添加</el-button>
            </template>
          </el-table-column>
        </tableList>
      </div>
      <div class="top-title add-wrap">已添加商品</div>
      <el-table ref="addTable" size="small" :data="addList" style="width: 100%">
        <el-table-column prop="productNo" label="商品SKU" />
        <el-table-column prop="productName" label="商品名称" />
        <el-table-column prop="categories" label="分类">
          <template v-slot="{ row }">
            <template v-if="row.categories">
              <div v-for="item in row.categories.split('，')" :key="item">{{ item }}</div>
            </template>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="newFlag" label="是否新品">
          <template v-slot="{ row }">
            {{ row.newFlag === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaLink" label="商品图片">
          <template v-slot="{row}">
            <div class="img-box" style="width:75px; height: 75px">
              <img v-if="row.mediaLink" class="product-img" :src="row.mediaLink" alt="">
              <div v-else style="line-height: 75px;">--</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="qty" label="库存" />
        <el-table-column prop="soldQty" label="销量" />
        <el-table-column prop="isHot" label="是否热卖商品">
          <template v-slot="{ row }">
            {{ row.isHot === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex btns">
        <el-button type="info" @click="cancelBtn">取消</el-button>
        <el-button type="primary" @click="submit">保存并应用</el-button>
      </div>
    </div>

  </div>
</template>
<script>

import tableList from "@/components/TableList";

export default {
  components: {
    tableList,
  },

  data() {
    return {
      search: {
        sku: '',
      },
      searchList: [], // 搜索的结果
      addList: [], // 添加的结果
      tagId: null, // 系列id
    };
  },

  mounted() {
    const { query } = this.$route;
    if (query.tagId) {
      this.tagId = query.tagId;
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      this.$Api.equipment.getEquipmentByTagId(Number(this.tagId)).then(res => {
        if (res && res.length) {
          this.addList = res;
        }
      });
    },
    add(row) {
      const len = this.addList.filter(item => item.productNo === row.productNo);
      if (len.length) {
        this.$message.warning('请不要添加重复商品');
        return;
      }
      this.addList.push(row);
    },
    remove(row) {
      this.addList = this.addList.filter(item => item.productNo !== row.productNo);
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    cancelBtn() {
      this.$router.go(-1);
    },
    submit() {
      if (!this.tagId) return;
      const ids = this.addList.map(item => item.productNo);
      this.$Api.equipment.postEquipmentSave({
        skus: ids,
        tagId: Number(this.tagId),
      }).then(res => {
        console.log('res===>', res);
        this.$message.success('保存成功');
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      }).catch((err) => {
        console.log('error===>', err);
      });
    },
  },
};

</script>
<style lang="less" scoped>
.table-wrap {
  position: relative;
  padding-bottom: 80px;
}
.img-box {
  position: relative;
  .invalid-flag {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%) rotateZ(20deg);
    z-index: 2;
    width: 92px;
    height: 36px;
  }
  .product-img {
    width: 100%;
    height: 100%;
  }
}
.seriesOfClass-edit {
  .btns {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
  }
  .top-title {
    color: #494949;
    line-height: 23px;
    font-weight: 500;
    margin-bottom: 30px;
    &.add-wrap {
      margin-top: 50px;
    }
  }
}
</style>
